import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { images } from '../data/images';
import { Reveal } from './Reveal';
const principles = [{
  title: 'Wat het is',
  text: 'De herkomst en samenstelling, zonder omhaal.'
}, {
  title: 'Wat het doet',
  text: 'Eerlijke werking, zonder wonderclaims.'
}, {
  title: 'Hoe je het gebruikt',
  text: 'Een helder ritueel, stap voor stap.'
}];
export function Concept() {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'center center']
  });
  const inset = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['8%', '0%']);
  const radius = useTransform(scrollYProgress, [0, 1], reduce ? ['2rem', '2rem'] : ['4rem', '2rem']);
  const clipPath = useTransform(inset, v => `inset(0 ${v} 0 ${v})`);
  return <section id="concept" className="py-24 lg:py-32" data-id="element-1" data-mp="81jq7sty8vpx">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-12 lg:items-end lg:px-10" data-id="element-2" data-mp="84xs6zypb2wu">
        <Reveal className="lg:col-span-7" data-id="element-3" data-mp="2ctkhnzlgcbgd">
          <h2 className="font-display text-5xl font-medium leading-[0.95] text-ink sm:text-7xl" data-id="element-4" data-mp="2htgjptal9sta">
            Marokkaanse beauty, <span className="italic text-clay" data-id="element-5" data-mp="22wphzddg050i">als moderne skincare.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.05} className="lg:col-span-4 lg:col-start-9" data-id="element-6" data-mp="27ur11yavc4bz">
          <p className="text-lg leading-relaxed text-muted" data-id="element-7" data-mp="1u4nmzum57gxm">
            Korean skincare liet zien hoe traditionele ingrediënten en rituelen een wereldwijde trend worden. Amira ziet dezelfde
            potentie in Marokko: producten die al generaties bestaan, maar nog nooit als één moderne categorie zijn gepresenteerd.
          </p>
        </Reveal>
      </div>

      <div ref={ref} className="mx-auto mt-16 max-w-[1600px] px-4 lg:px-6" data-id="element-8" data-mp="1b61gu1brqzmu">
        <motion.div style={{
        clipPath,
        borderRadius: radius
      }} className="overflow-hidden" data-id="element-9" data-mp="1b85vneb7hj1w">
          <img src={images.souk} alt="Een kraam in de souk met zwarte zeep, ghassoul, nila, rozenblaadjes en kessa-handschoenen" className="aspect-[16/9] w-full object-cover lg:aspect-[21/9]" data-id="element-10" data-mp="1f6v3yshe0aeo" />
        </motion.div>
      </div>

      <ul className="mx-auto mt-16 grid max-w-7xl gap-10 px-6 sm:grid-cols-3 lg:px-10" data-id="element-11" data-mp="385jvlgzj7r5o">
        {principles.map((p, i) => <li key={p.title} data-id="element-12" data-mp="3378o3cwplsqm" data-mpi={i}>
            <Reveal delay={i * 0.05} className="border-t border-ink pt-6" data-id="element-13" data-mp="4ns3m2leb77h">
              <h3 className="font-display text-4xl text-ink" data-id="element-14" data-mp="4lpavasuyzz2">{p.title}</h3>
              <p className="mt-2 text-muted" data-id="element-15" data-mp="3vumees5wjq1r">{p.text}</p>
            </Reveal>
          </li>)}
      </ul>
      <p className="mx-auto mt-12 max-w-7xl px-6 text-sm leading-relaxed text-muted lg:px-10" data-id="element-16" data-mp="3qt6td03q5jjd">
        We starten met de pure, natuurlijke producten. Later bouwen we uit naar formules waarin deze ingrediënten verwerkt worden.
      </p>
    </section>;
}